import React from "react";
import { monthConverter } from "utils/common";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const calculateTotal = () => {
    if (currentLevel === "nasional") {
      return reportsData.reduce(
        (total, item) => {
          total.total_faskes += parseInt(item.total_faskes) || 0;
          total.total_faskes_zero_report +=
            parseInt(item.total_faskes_zero_report) || 0;

          return total;
        },
        {
          total_faskes: 0,
          total_faskes_zero_report: 0,
        }
      );
    } else {
      return reportsData.reduce(
        (total, item) =>
          total + (item.is_zero_reporting?.toLowerCase() === "ya" ? 1 : 0),
        0
      );
    }
  };

  const renderTableByLevel = () => {
    const total = calculateTotal();

    switch (currentLevel) {
      case "nasional":
        return (
          <>
            <thead>
              <tr>
                <th style={{ textAlign: "center", width: "80px" }}>No</th>
                <th>BKK Induk</th>
                <th>Tahun</th>
                <th>Total Wilker</th>
                <th>Jumlah Wilker yang Pernah Lapor Zero Reporting</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ width: "80px" }}>{index + 1}</td>
                    <td>{item?.bkk_induk}</td>
                    <td>{item?.year}</td>
                    <td>{item?.total_wilker}</td>
                    <td>{item?.jumlah_wilker_lapor_zero_report}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={3}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{total.total_wilker}</td>
                <td style={{ color: "#FFF" }}>
                  {total.jumlah_wilker_lapor_zero_report}
                </td>
              </tr>
            </tbody>
          </>
        );
      default:
        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>BKK Pencatat</th>
                <th>Tahun</th>
                <th>Bulan</th>
                <th>Zero Reporting</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.bkk_name}</td>
                    <td>{item?.year}</td>
                    <td>{monthConverter(item?.month)}</td>
                    <td>{item?.is_zero_reporting}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={4}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{total}</td>
              </tr>
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === "nasional") {
    levelName = "Nasional";
  } else if (currentLevel === "induk") {
    levelName = "BKK Induk";
  } else {
    levelName = "BKK Wilker";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, ZERO REPORTING BKK</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {reportInfo?.statusPeriode === "monthly" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Induk
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.induk
              ? "Semua BKK Induk"
              : reportInfo?.induk?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Wilker</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            :{" "}
            {!reportInfo?.wilker
              ? "Semua BKK Wilker"
              : reportInfo?.wilker?.split("|")[1]}
          </th>
        </tr>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
